/************************************************************************************************
 * Copyright TRUSST AI PTY LTD. All Rights Reserved.                                            *
 *                                                                                              *
 * Licensed under the TRUSST SOFTWARE LICENSE (the "License"). You may not use this file except *
 * in compliance with the "LICENSE" file accompanying this file. This file is distributed       *
 * on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, express or implied.       *
 *                                                                                              *
 * See the "License" file for the specific language governing permissions and limitations       *
 * under the License and limitations under the License.                                         *
 ***********************************************************************************************/

import {PERMISSIONS} from '@agent-assist/common/lib/admin/rbac';
import {Card, CardContent} from '@mui/material';
import CardHeader from '@mui/material/CardHeader';
import {useFlags} from 'launchdarkly-react-client-sdk';
import {useState, ReactNode} from 'react';
import {ConfigureMappings} from './ConfigureMappings';
import {MyTeamPage} from './MyTeamPage';
import {OrganisationDetails} from './OrganisationDetails';
import {PageContainer} from '../../components/PageContainer';
import {FeatureFlagSet, FeatureFlags} from '../../flags';
import {useUserStore} from '../../stores/userStore';

export const Settings = () => {
  const [orgActions, setOrgActions] = useState<ReactNode>(null);
  const [teamsActions, setTeamsActions] = useState<ReactNode>(null);
  const flags = useFlags<FeatureFlagSet>();
  const permissionsMap = useUserStore((state) => state.permissionsMap);

  const showTeamsAndUsers = flags[FeatureFlags.teamsAndUsersFilters] && permissionsMap[PERMISSIONS.SETTINGS_UPDATE];

  return (
    <PageContainer title={'Settings'} compact>
      <Card>
        <CardHeader title={'My Organisation'} action={orgActions} />
        <CardContent>
          <OrganisationDetails setActions={setOrgActions} />
        </CardContent>
      </Card>

      {showTeamsAndUsers && (
        <Card>
          <CardHeader title={'My Team'} action={teamsActions} />
          <CardContent>
            <MyTeamPage setActions={setTeamsActions} />
          </CardContent>
        </Card>
      )}

      <Card>
        <CardHeader title={'Continuous Ingestion Mappings'} />
        <CardContent>
          <ConfigureMappings
            onUpload={async (file, type) => {
              console.log(file, type);
              await Promise.resolve();
            }}
          />
        </CardContent>
      </Card>
    </PageContainer>
  );
};

export default Settings;
